// extracted by mini-css-extract-plugin
module.exports = {"container":"trimmed-container-module--container--a2hr6"};